import { Form as FactorialForm } from 'factorial-form'

export const PeriodScheduleType = {
  flexible: 'flexible',
  fixed: 'fixed',
}

class PeriodScheduleTypeForm extends FactorialForm {
  constructor(values: object) {
    super(values, {
      schedule_type: 'string',
    })
  }
}
